<highcharts-chart
        [options]="chartOptions"
        style="width: 100%; height: auto; display: block;"
>
</highcharts-chart>